import { useNavigate } from "react-router-dom";

export const BallerzToken = () => {

  let user = localStorage.getItem("ballerz-user");

  if (!user) {
    return false;
  }

  let ballerzParsed = JSON.parse(user);

  if (!ballerzParsed.token) {
    return false;
  }

  return ballerzParsed.token;
};

export const BallerzUserID = () => {

  let user = localStorage.getItem("ballerz-user");

  if (!user) {
    return false;
  }

  let ballerzParsed = JSON.parse(user);

  if (!ballerzParsed.ballerzUserID) {
    return false;
  }

  return ballerzParsed.ballerzUserID;
};

export const BallerzUsers = () => {

  let user = localStorage.getItem("ballerz-user");

  if (!user) {
    return false;
  }

  let ballerzParsed = JSON.parse(user);

  if (!ballerzParsed.users) {
    return [];
  }

  return ballerzParsed.users;
};

export const BallerzChangeUser = (ballerzUserID) => {

  let user = localStorage.getItem("ballerz-user");

  let ballerzParsed = JSON.parse(user);

  ballerzParsed.ballerzUserID = ballerzUserID;

  localStorage.setItem("ballerz-user", JSON.stringify(ballerzParsed));

};

export const BallerzRedirect = () => {
    const navigate = useNavigate();
    navigate(`/login`);
}